import { ApolloCache } from '@apollo/client';
import { UserQuery } from '../../graphql/queries';

const deleteCachedFieldsOnUserQuery = (cache: ApolloCache<any>, keysToDelete: string[]): void => {
  const userQueryRes = cache.readQuery<any>({
    query: UserQuery,
    returnPartialData: true,
  });

  const fieldsObject: any = keysToDelete.reduce((acc: any, val: string) => {
    acc[val] = (_fieldValue: any, details: any) => details.DELETE;
    return acc;
  }, {});

  cache.modify({
    id: cache.identify(userQueryRes?.currentUserQuery),
    fields: fieldsObject,
  });

  cache.gc();
};

export default deleteCachedFieldsOnUserQuery;
